import React from 'react';
import ReactDOM from 'react-dom';

import Container from './container';
import { contextLoader } from '../common/services/context-loader';
import Wix from '../common/services/wix-sdk-polyfill';
import { reducer } from './state';
import { ROOT_ID } from '../common/constants/dom';

const { store, i18n, fedops } = contextLoader({ reducer, shouldListenToUserChange: false });

ReactDOM.render(<Container store={store} i18n={i18n} />, document.querySelector(`#${ROOT_ID}`), () => {
  Wix.Performance.applicationLoaded();
  fedops.appLoaded();
});
